export default "__VITE_ASSET__LN8pvL7p__"